import { createSlice } from "@reduxjs/toolkit";
import {
  createApiThunkPrivate,
  createApiThunkPrivateImage,
  createExtraReducersForThunk,
} from "../../utils/apiThunk";

const initialState = {
  value: 0,
  loading: false,
  error: "",
  getQuestionBySetData: {},
  getStudentListByAdminData: {},
  createNewStudentData: {},
  getAllUserSelectedData: {},
  getBoardListData: {},
  deleteStudentData: {},
  updateStudentData: {},
  getNotificationData: {},
  sendNotificationForUserData: {},
  uploadImageData: {},
  getAllDonerData: {},
  getAllVersionsData: {},
  addAppVersionData: {},
  updateAppVersionData: {},
  deleteBoardData: {},
  createBoardData: {},
  getTicketListData: {},
  getMsgListByTicketIdData: {},
  replyByAdminForTicketData: {},
  updateAdminPasswordData: {},
  getLoginHistoryListData: {},
  deleteQuestionData: {},
  getQuestionByIdData: {},
  getLanguageListForAdminData: {},
  createNewQuestionData: {},
  getIntroductionByIdData: {},
  updateIntroductionData: {},
  getPageListData: {},
  getPageByIdData: {},
  updatePageData: {},
  getSkillIndicatorListData: {},
  createNewSkillIndicatorData: {},
  deleteSkillIndicatorData: {},
  updateSkillIndicatorData: {},
  resolveTicketData: {},
};
export const getQuestionBySet = createApiThunkPrivate(
  "getQuestionBySet",
  "/getQuestionBySet"
);
export const getStudentListByAdmin = createApiThunkPrivate(
  "getStudentListByAdmin",
  "/getStudentListByAdmin"
);
export const createNewStudent = createApiThunkPrivate(
  "createNewStudent",
  "/createNewStudent"
);
export const getAllUserSelected = createApiThunkPrivate(
  "getAllUserSelected",
  "/getAllUserSelected"
);
export const getBoardList = createApiThunkPrivate(
  "getBoardList",
  "/getBoardList"
);
export const deleteStudent = createApiThunkPrivate(
  "deleteStudent",
  "/deleteStudent"
);
export const updateStudent = createApiThunkPrivate(
  "updateStudent",
  "/updateStudent"
);
export const getNotification = createApiThunkPrivate(
  "getNotification",
  "/getNotification"
);
export const sendNotificationForUser = createApiThunkPrivate(
  "sendNotificationForUser",
  "/sendNotificationForUser"
);
export const uploadImage = createApiThunkPrivateImage(
  "uploadImage",
  "/api/upload"
);
export const uploadAudio = createApiThunkPrivateImage(
  "uploadImage",
  "/api/upload-audio"
);

export const getAllDoner = createApiThunkPrivate("getAllDoner", "/getAllDoner");
export const getAllVersions = createApiThunkPrivate(
  "getAllVersions",
  "/adminVersionList"
);
export const addAppVersion = createApiThunkPrivate(
  "addAppVersion",
  "/addAppVersion"
);

export const updateAppVersion = createApiThunkPrivate(
  "updateAppVersion",
  "/updateAppVersion"
);

export const deleteBoard = createApiThunkPrivate("deleteBoard", "/deleteBoard");
export const resolveTicket = createApiThunkPrivate(
  "resolveTicket",
  "/resolvedTicket"
);

export const createBoard = createApiThunkPrivate("createBoard", "/createBoard");
export const getTicketList = createApiThunkPrivate(
  "getTicketList",
  "/getTicketList"
);
export const getMsgListByTicketId = createApiThunkPrivate(
  "getMsgListByTicketId",
  "/getMsgListByTicketId"
);
export const replyByAdminForTicket = createApiThunkPrivate(
  "replyByAdminForTicket",
  "/replyByAdminForTicket"
);
export const updateAdminPassword = createApiThunkPrivate(
  "updateAdminPassword",
  "/updateAdminPassword"
);
export const getLoginHistoryList = createApiThunkPrivate(
  "getLoginHistoryList",
  "/getLoginHistoryList"
);
export const deleteQuestion = createApiThunkPrivate(
  "deleteQuestion",
  "/deleteQuestion"
);
export const getQuestionById = createApiThunkPrivate(
  "getQuestionById",
  "/getQuestionById"
);
export const getLanguageListForAdmin = createApiThunkPrivate(
  "getLanguageListForAdmin",
  "/getLanguageListForAdmin"
);
export const createNewQuestion = createApiThunkPrivate(
  "createNewQuestion",
  "/createNewQuestion"
);
export const getIntroductionById = createApiThunkPrivate(
  "getIntroductionById",
  "/getIntroductionById"
);
export const updateIntroduction = createApiThunkPrivate(
  "updateIntroduction",
  "/updateIntroduction"
);
export const getPageList = createApiThunkPrivate("getPageList", "/getPageList");
export const getPageById = createApiThunkPrivate("getPageById", "/getPageById");
export const updatePage = createApiThunkPrivate("updatePage", "/updatePage");
export const getSkillIndicatorList = createApiThunkPrivate(
  "getSkillIndicatorList",
  "/getSkillIndicatorList"
);
export const createNewSkillIndicator = createApiThunkPrivate(
  "createNewSkillIndicator",
  "/createNewSkillIndicator"
);
export const deleteSkillIndicator = createApiThunkPrivate(
  "deleteSkillIndicator",
  "/deleteSkillIndicator"
);
export const updateSkillIndicator = createApiThunkPrivate(
  "updateSkillIndicator",
  "/updateSkillIndicator"
);
export const QuestionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createExtraReducersForThunk(
      builder,
      getQuestionBySet,
      "getQuestionBySetData"
    );
    createExtraReducersForThunk(
      builder,
      getStudentListByAdmin,
      "getStudentListByAdminData"
    );
    createExtraReducersForThunk(
      builder,
      createNewStudent,
      "createNewStudentData"
    );
    createExtraReducersForThunk(
      builder,
      getAllUserSelected,
      "getAllUserSelectedData"
    );
    createExtraReducersForThunk(builder, getBoardList, "getBoardListData");
    createExtraReducersForThunk(builder, deleteStudent, "deleteStudentData");
    createExtraReducersForThunk(builder, updateStudent, "updateStudentData");
    createExtraReducersForThunk(
      builder,
      getNotification,
      "getNotificationData"
    );
    createExtraReducersForThunk(
      builder,
      sendNotificationForUser,
      "sendNotificationForUserData"
    );
    createApiThunkPrivateImage(builder, uploadImage, "uploadImageData");
    createExtraReducersForThunk(builder, getAllDoner, "getAllDonerData");
    createExtraReducersForThunk(builder, getAllVersions, "getAllVersionsData");
    createExtraReducersForThunk(builder, addAppVersion, "addAppVersionData");
    createExtraReducersForThunk(
      builder,
      updateAppVersion,
      "updateAppVersionData"
    );
    createExtraReducersForThunk(builder, deleteBoard, "deleteBoardData");
    createExtraReducersForThunk(builder, resolveTicket, "resolveTicketData");

    createExtraReducersForThunk(builder, createBoard, "createBoardData");
    createExtraReducersForThunk(builder, getTicketList, "getTicketListData");
    createExtraReducersForThunk(
      builder,
      getMsgListByTicketId,
      "getMsgListByTicketIdData"
    );
    createExtraReducersForThunk(
      builder,
      replyByAdminForTicket,
      "replyByAdminForTicketData"
    );
    createExtraReducersForThunk(
      builder,
      updateAdminPassword,
      "updateAdminPasswordData"
    );
    createExtraReducersForThunk(
      builder,
      getLoginHistoryList,
      "getLoginHistoryListData"
    );
    createExtraReducersForThunk(builder, deleteQuestion, "deleteQuestionData");
    createExtraReducersForThunk(
      builder,
      getQuestionById,
      "getQuestionByIdData"
    );
    createExtraReducersForThunk(
      builder,
      getLanguageListForAdmin,
      "getLanguageListForAdminData"
    );
    createExtraReducersForThunk(
      builder,
      createNewQuestion,
      "createNewQuestionData"
    );
    createExtraReducersForThunk(
      builder,
      getIntroductionById,
      "getIntroductionByIdData"
    );
    createExtraReducersForThunk(
      builder,
      updateIntroduction,
      "updateIntroductionData"
    );
    createExtraReducersForThunk(builder, getPageList, "getPageListData");
    createExtraReducersForThunk(builder, getPageById, "getPageByIdData");
    createExtraReducersForThunk(builder, updatePage, "updatePageData");
    createExtraReducersForThunk(
      builder,
      getSkillIndicatorList,
      "getSkillIndicatorListData"
    );
    createExtraReducersForThunk(
      builder,
      createNewSkillIndicator,
      "createNewSkillIndicatorData"
    );
    createExtraReducersForThunk(
      builder,
      deleteSkillIndicator,
      "deleteSkillIndicatorData"
    );
    createExtraReducersForThunk(
      builder,
      updateSkillIndicator,
      "updateSkillIndicatorData"
    );
  },
});

export default QuestionSlice.reducer;
